import React from 'react';
import {APP_NAME} from '../../lib/brand';
import {isScratchDesktop} from '../../lib/isScratchDesktop';
import CloseButton from '../close-button/close-button.jsx';
import styles from './tw-news.css';
import {isNewYearMode} from '../dash-new-year-mode/new-year-mode.jsx';

const getIsClosedInLocalStorage = (key, id) => {
    try {
        return localStorage.getItem(key) === id;
    } catch (e) {
        return false;
    }
};

const markAsClosedInLocalStorage = (key, id) => {
    try {
        localStorage.setItem(key, id);
    } catch (e) {
        // ignore
    }
};

class TWNews extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            closed: getIsClosedInLocalStorage(props.item, props.id)
        };
        this.handleCloseNewCompiler = this.handleCloseNewCompiler.bind(this);
        this.handleCloseDevVersion = this.handleCloseDevVersion.bind(this);
        this.handleCloseNewYear = this.handleCloseNewYear.bind(this);
    }
    handleCloseNewCompiler () {
        markAsClosedInLocalStorage(this.props.item, this.props.id);
        this.setState({
            closed: true
        }, () => {
            window.dispatchEvent(new Event('resize'));
        });
    }
    handleCloseDevVersion () {
        markAsClosedInLocalStorage(this.props.item, this.props.id);
        this.setState({
            closed: true
        }, () => {
            window.dispatchEvent(new Event('resize'));
        });
    }
    handleCloseNewYear () {
        markAsClosedInLocalStorage(this.props.item, this.props.id);
        this.setState({
            closed: true
        }, () => {
            window.dispatchEvent(new Event('resize'));
        });
    }
    render () {
        if (this.state.closed || isScratchDesktop()) {
            return null;
        }
        return (
            <>
                {this.props.id == 'new-compiler' && (<div className={styles.news}>
                    <div className={styles.text}>
                        {/* eslint-disable-next-line max-len */}
                        {`We rewrote the ${APP_NAME} compiler to make projects run even faster. Bugs are possible. `}
                        <a
                            href="https://dashblocks.github.io/docs/new-compiler"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {'Learn more.'}
                        </a>
                        {' '}
                        <a
                            href="https://dashblocks.github.io/old-compiler"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {'Old compiler.'}
                        </a>
                    </div>
                    <CloseButton
                        className={styles.close}
                        onClick={this.handleCloseNewCompiler}
                    />
                </div>)}
                {this.props.id == 'new-year' && (<div className={styles.news}>
                    <div className={styles.text}>
                        {/* eslint-disable-next-line max-len */}
                        {`Happy New Year! Enjoy the festive theme while it lasts. `}
                        <a
                            href={isNewYearMode() ? 'https://t-smod.github.io/scratch-gui/' : 'https://t-smod.github.io/scratch-gui/?newYearMode'}
                            rel="noreferrer"
                        >
                            {isNewYearMode() ? 'Switch to normal mode.' : 'Switch to new year mode.'}
                        </a>
                    </div>
                    <CloseButton
                        className={styles.close}
                        onClick={this.handleCloseNewYear}
                    />
                </div>)}
            </>
        );
    }
}

export default TWNews;
